const forms = (): void => {
  const selects = document.querySelectorAll<HTMLSelectElement>('.wpcf7 select');

  selects.forEach((select) => {
    select.addEventListener('change', (e) => {
      e.stopPropagation();
      if (select.selectedIndex > 0) {
        select.classList.add('has-value');
      } else {
        select.classList.remove('has-value');
      }
    });
  });
};

export default forms;
